/**
 * Empresas emisoras simuladas.
 * Futuro: reemplazar por issuerCompanyRepository + Supabase.
 */
export const MOCK_COMPANIES = [
	{
		id: "empresa-afecta",
		nombreLegal: "DeNegocios Servicios Empresariales SpA",
		nombreFantasia: "DeNegocios.cl",
		rut: "76.123.456-7",
		telefono: "+56 9 1234 5678",
		correo: "contacto@denegocios.cl",
		direccion: "Av. Providencia 1234, Santiago, Chile",
		tipoTributario: "afecta",
		tasaIva: 19,
		prefijoNumero: "DN",
		// Logo simulado: inicial/texto (sin archivo binario en esta etapa)
		logo: "DN",
		logoColor: "#1a365d",
	},
	{
		id: "empresa-exenta",
		nombreLegal: "Asesorías Profesionales DeNegocios Ltda.",
		nombreFantasia: "DeNegocios Asesorías",
		rut: "77.987.654-3",
		telefono: "+56 9 8765 4321",
		correo: "asesorias@denegocios.cl",
		direccion: "Av. Apoquindo 4500, Las Condes, Santiago, Chile",
		tipoTributario: "exenta",
		tasaIva: 0,
		prefijoNumero: "AE",
		logo: "AE",
		logoColor: "#276749",
	},
];

export const getCompanyById = (id) =>
	MOCK_COMPANIES.find((company) => company.id === id) || null;

export const createIssuerSnapshot = (company) => {
	if (!company) return null;
	return {
		nombreLegal: company.nombreLegal,
		nombreFantasia: company.nombreFantasia,
		rut: company.rut,
		telefono: company.telefono,
		correo: company.correo,
		direccion: company.direccion,
		logo: company.logo,
		logoColor: company.logoColor,
		tipoTributario: company.tipoTributario,
		tasaIva: company.tasaIva,
		prefijoNumero: company.prefijoNumero,
	};
};
